<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <span style="height: 20px;">{{rfc}} // {{name}} &nbsp;<CIcon :height="20" name="cil-cog" /></span>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader tag="div" class="text-center" color="light">
      <strong>Configuración General</strong>
    </CDropdownHeader>
    <CDropdownItem href="#/my-account">
      <CIcon name="cil-user" /> Mi Cuenta
    </CDropdownItem>
    <CDropdownItem href="#/my-subscription">
      <CIcon name="cil-briefcase" /> Mi Suscripción
    </CDropdownItem>    
    <CDropdownHeader tag="div" class="text-center" color="light">
      <strong>Mi Facturación</strong>
    </CDropdownHeader>
    <CDropdownItem href="#/fiscal">
      <CIcon name="cil-contact" /> Información Fiscal
    </CDropdownItem>
    <CDropdownItem href="#/fiel">
      <CIcon name="cil-https" /> Fiel
    </CDropdownItem>
    <CDropdownItem href="#/certificates">
      <CIcon name="cil-check-circle" /> Certificados
    </CDropdownItem>
    <CDropdownItem href="#/serials">
      <CIcon name="cil-text-size" /> Series y Folios
    </CDropdownItem>
    <CDropdownDivider/>
    <CDropdownItem href="#/fiscal-products">
      <CIcon name="cil-truck" /> Próductos ( SAT )
    </CDropdownItem>
    <CDropdownDivider/>
    <CDropdownItem href="#/taxes">
      <CIcon name="cil-balance-scale" /> Impuestos
    </CDropdownItem>
    <CDropdownItem href="#/currencies">
      <CIcon name="cil-money" /> Monedas
    </CDropdownItem>
    <CDropdownItem href="#/units">
      <CIcon name="cil-3d" /> Unidades
    </CDropdownItem>
    <CDropdownDivider/>
    <CDropdownItem @click="logout">
      <CIcon name="cil-lock-locked" /> Cerrar Sesión
    </CDropdownItem>
  </CDropdown>
</template>

<script>
import router from '../router/index'
import store from '../store'
import account_ws from '../services/account';

export default {
  name: 'TheHeaderDropdownAccnt',
  data () {
    return { 
      rfc: '',
      name: '',
      deadline: '',
      deadline_days: 1000,
      deadline_date: '',
      stamps: 100
    }
  },
  mounted: async function() {
    let response = await account_ws.getFiscalInfo(); 

    if(response.type == "success"){
      this.rfc = response.data.rfc;
      this.name = response.data.fiscal_name;
    }

    let response2 = await account_ws.getAccountDetails(); 

    if(response2.type == "success"){
      this.stamps = response2.data.stamps;
      this.deadline = response2.data.deadline;
      this.deadline_days = response2.data.deadline_days;
      this.deadline_date = response2.data.deadline_date;

      store.commit('setAccount', response2.data.account_id);
      store.commit('setStamps', response2.data.stamps);
      store.commit('setDeadlineDays', response2.data.deadline_days);
      store.commit('setDeadlineDate', response2.data.deadline_date);
    }
  },
  methods: {
    logout: function(){
      localStorage.removeItem("token");
      store.commit('clear');
      router.push("login");
    },
  }
}
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>